/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;

// ==============================================================================
// Provides a generic popover.
// ------------------------------------------------------------------------------

// Needs to be in sync with the variable $animSpeed in okpopover.scss
let animationSpeed = Modernizr.cssanimations ? 150 : 0;

window.OkPopover = class OkPopover {
	// Initialization functions
	// -----------------------------------------------

	// id - string - ID to assign to the popover.
	//
	// Required params:
	//		id (string)		 - ID of the popover
	//		message (string)	- Message text
	//		direction (string)  - Direction of the popover
	//		target (obj) - jQuery object, or selector string
	//
	// Optional parameters in defaults object below
	//
	constructor(params) {
		if (
			params.id == null ||
			params.message == null ||
			params.direction == null ||
			params.target == null
		) {
			console.log("Insufficient parameters");
			return;
		}

		let defaults = {
			padding: 0,
			classes: "",
			inline: false,
		};
		$.extend(this, defaults, params);

		// If they passed a selector, get it.
		if (typeof this.target === "string") {
			this.target = $(params.target);
		}

		if (!this.target.length) {
			return;
		}

		// Template
		let classes = `popover okpopover aligncenter arrow${this.direction}`;

		if (this.classes) {
			classes = `${classes} ${this.classes}`;
		}

		let markup =
			`\
<div id="${this.id}" class="${classes}">
	<div class="contents">
		<h2 class="title">${this.heading}</h2>
		<p class="desc">
			${this.message}
		</p>
		<div class="buttons">
			<ul>\
` +
			this.buttons.map(button => `<li>${button}</li>`) +
			`\
			</ul>
		</div>
	</div>
	<div class="tail"></div>
</div>\
`;

		// Place it at the body, for easier positioning and not dealing with overflow
		this.popover = $(markup);
		// Check if it exists, and if so, replace it.
		if ($(`#${this.id}`).length) {
			$(`#${this.id}`).replaceWith(this.popover);
		} else {
			if (this.inline) {
				$(this.target).parent().append(this.popover);
			} else {
				$("body").append(this.popover);
			}
		}

		this.popover = $(`#${this.id}`);
		this.center();

		// Needs repositioning on resize since it's at the body.
		$(window).resize(() => {
			if (this.popover.hasClass("open")) {
				return this.center(true);
			}
		});
		// If the target's scroll parent isn't the document, we'll also need to
		// reposition on scroll.
		if (this.target.scrollParent() !== this.popover.scrollParent()) {
			this.target.scrollParent().scroll(() => {
				if (this.isOpen()) {
					return this.center(true);
				}
			});
		}

		return this;
	}

	// Event-based functions
	// -----------------------------------------------

	isOpen() {
		return this.popover.hasClass("open");
	}

	open() {
		if (!this.target.length) {
			return;
		}

		return this.openPopover();
	}

	openPopover() {
		this.center();
		this.popover.addClass("open");
		setTimeout(() => {
			// Prevent the open animation from playing again while it's open.
			return this.popover.addClass("no_open_animation");
		}, animationSpeed);

		return this;
	}

	close() {
		if (this.popover.hasClass("open")) {
			this.popover.addClass("closing").removeClass("open no_open_animation");
			setTimeout(() => {
				return this.popover.removeClass("closing");
			}, animationSpeed);
		}

		return this;
	}

	changeDirection(dir) {
		this.popover.removeClass(`arrow${this.direction}`).addClass(`arrow${dir}`);
		this.direction = dir;
		this.center();
		return this;
	}

	changeTarget(newTarget) {
		this.target = newTarget;
		if (this.inline) {
			this.target.after(this.popover);
		}
		this.center();
		return this;
	}

	changeMessage(newMsg) {
		this.popover.find(".msg").html(newMsg);
		this.center();
		return this;
	}

	changeHeading(newHeading) {
		this.popover.find(".heading .title").html(newHeading);
		if (newHeading) {
			this.popover.addClass("has_heading");
		} else {
			this.popover.removeClass("has_heading");
		}
		this.center();
		return this;
	}

	changePadding(padding) {
		this.padding = padding;
		this.center();
		return this;
	}

	// Determine position. Not exceptionally elegant.
	// noAnimation - Self explanitory, forces animation off.
	// force - Forces it center, even if not open.
	center(noAnimation) {
		if (!this.target.length) {
			return;
		}
		if (noAnimation) {
			this.popover.addClass("noanimation");
		}

		let { top } = this.target.offset();
		let { left } = this.target.offset();
		let elementWidth = this.target.outerWidth();
		let elementHeight = this.target.outerHeight();
		let popoverWidth = this.popover.outerWidth();
		let popoverHeight = this.popover.outerHeight();
		let arrowWidth = this.popover.find(".tail").outerWidth();
		let arrowHeight = this.popover.find(".tail").outerHeight();

		// if getting the size of the arrow failed, make it not display none and
		// try again
		if (arrowWidth === 0 || arrowHeight === 0) {
			this.popover.addClass("invisible");
			arrowWidth = this.popover.find(".tail").outerWidth();
			arrowHeight = this.popover.find(".tail").outerHeight();
			this.popover.removeClass("invisible");
		}

		if (this.inline) {
			top -= this.target.offsetParent().offset().top;
			left -= this.target.offsetParent().offset().left;
		}

		if (this.direction === "top" || this.direction === "bottom") {
			left = Math.floor(left + elementWidth / 2 - popoverWidth / 2);
		} else if (this.direction === "left" || this.direction === "right") {
			top = Math.floor(top + elementHeight / 2 - popoverHeight / 2);
		}

		if (this.direction === "right") {
			left = left + elementWidth + arrowHeight + this.padding;
		} else if (this.direction === "left") {
			left = left - popoverWidth - arrowWidth - this.padding;
		} else if (this.direction === "bottom") {
			top = top + elementHeight + arrowHeight + this.padding;
		} else if (this.direction === "top") {
			top = top - popoverHeight - arrowHeight - this.padding;
		}

		this.popover.css("top", top);
		this.popover.css("left", left);

		if (noAnimation) {
			this.popover.css("top");
			this.popover.css("left");
			this.popover.removeClass("noanimation");
		}

		return this;
	}
};



// WEBPACK FOOTER //
// ./src/legacy/okpopover.js